import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions';

import UserApi from '../../apis/user';
import SessionApi from '../../apis/session';
import LocationsApi from '../../apis/locations';


export const fetchPublicPreferences = () => {
  return dispatch => {
    dispatch(execApi({
        type: types.PUBLIC_PREFERENCES,
        api: SessionApi.getAllPublicPreferences,
        successCallback: response => {
          dispatch({
            type: types.PUBLIC_PREFERENCES,
            payload: response.preferences,
          });
        },
      })
    );
  };
};

export const fetchAuthenticatedPreferences = () => {
  return dispatch => {
    dispatch(execApi({
        type: [
          types.AUTHENTICATED_PREFERENCES,
          types.ACCOUNT_PREFERENCES,
          types.LOCATIONS_PREFERENCES,
          types.USER_PREFERENCES,
        ],
        api: UserApi.getDetails,
        successCallback: response => {

          dispatch({
            type: types.AUTHENTICATED_PREFERENCES,
            payload: response.account.location.preferences,
          });

          dispatch({
            type: types.ACCOUNT_PREFERENCES,
            payload: response.account,
          });

          dispatch({
            type: types.LOCATIONS_PREFERENCES,
            payload: response.locations,
          });

          dispatch({
            type: types.USER_PREFERENCES,
            payload: response.user,
          });

        },
        useErrorDialog: false,
      })
    );
  };
};

export const switchLocation = (locationId, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
        type: types.LOCATIONS_PREFERENCES,
        api: LocationsApi.switchLocation,
        param: locationId,
        successCallback: response => {
          if (successCb) successCb(response);
        },
        errorCallback: () => {
          if (errorCb) errorCb();
        },
        useErrorDialog: true,
      })
    );
  };
};




// WEBPACK FOOTER //
// ./src/actions/preferences/preferencesAction.js